(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/game-analyses-redux/assets/game-analyses-selectors.js') >= 0) return;  svs.modules.push('/components/sportinfo/game-analyses-redux/assets/game-analyses-selectors.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const ReducerState = svs.components.sport.tipsenShared.ReducerState;
const drawKeyFromAction = (productId, drawNumber) => "".concat(productId, "_").concat(drawNumber);
const selectAuthorProfiles = state => state.gameAnalyses.authorProfiles;
const selectAuthorProfile = (state, authorId) => state.gameAnalyses.authorProfiles[authorId];
const selectDrawAnalyses = state => state.gameAnalyses.drawAnalyses;
const selectAnalysesByDraw = state => state.gameAnalyses.byDraw;
const selectMatchAnalyses = state => state.gameAnalyses.matchAnalyses;
const selectAnalysesByMatch = (state, matchId) => state.gameAnalyses.byMatchId[matchId];
const selectMatchAnalysis = (state, analysisId) => state.gameAnalyses.matchAnalyses[analysisId];
const selectDrawAnalysesIsDone = (state, productId, drawNumber) => state.gameAnalyses.drawAnalysesState[drawKeyFromAction(productId, drawNumber)] === ReducerState.Done;
const selectDrawAnalysesIsRejected = (state, productId, drawNumber) => state.gameAnalyses.drawAnalysesState[drawKeyFromAction(productId, drawNumber)] === ReducerState.Rejected;
const selectDrawAnalysesShouldShowSkeleton = (state, productId, drawNumber) => !selectDrawAnalysesIsDone(state, productId, drawNumber) && !selectDrawAnalysesIsRejected(state, productId, drawNumber);
const selectAllMatchAnalyseIdsForSpecificDraws = (state, drawIds) => {
  const currentDrawMatchAnalyseIds = [];
  drawIds.forEach(drawId => {
    currentDrawMatchAnalyseIds.push(state.gameAnalyses.drawAnalyses[drawId].gameAnalysesIds);
  });
  return currentDrawMatchAnalyseIds;
};
const selectAllMatchAnalysesByMatchIdAndEventNumber = (state, matchId, eventNumber) => {
  var _state$gameAnalyses;
  const allAnalysesByMatchId = (_state$gameAnalyses = state.gameAnalyses) !== null && _state$gameAnalyses !== void 0 && _state$gameAnalyses.byMatchId ? state.gameAnalyses.byMatchId[matchId] : undefined;
  const allAnalysesByMatchIdAndEventNumber = [];
  if (allAnalysesByMatchId && allAnalysesByMatchId.length > 0) {
    allAnalysesByMatchId.forEach(analyseId => {
      const currentAnalyse = state.gameAnalyses.matchAnalyses[analyseId];
      if (currentAnalyse.eventNumber === eventNumber) {
        allAnalysesByMatchIdAndEventNumber.push(analyseId);
      }
    });
  }
  return allAnalysesByMatchIdAndEventNumber;
};
const selectMatchAnalysIdsForSpecificDrawAndMatchAndEventNumber = function (state, productId, drawNumber, matchId) {
  let eventNumber = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  const analyseDrawIds = state.gameAnalyses.byDraw[drawKeyFromAction(productId, drawNumber)];
  let allPossibleMatchAnalyseIds = [];
  if (analyseDrawIds && analyseDrawIds.length > 0) {
    allPossibleMatchAnalyseIds = selectAllMatchAnalyseIdsForSpecificDraws(state, analyseDrawIds);
  }
  let allGameAnalyseMatchIds = [];
  if (eventNumber) {
    allGameAnalyseMatchIds = selectAllMatchAnalysesByMatchIdAndEventNumber(state, matchId, eventNumber);
  } else {
    var _state$gameAnalyses2;
    allGameAnalyseMatchIds = (_state$gameAnalyses2 = state.gameAnalyses) !== null && _state$gameAnalyses2 !== void 0 && _state$gameAnalyses2.byMatchId ? state.gameAnalyses.byMatchId[matchId] : undefined;
  }
  const idsToUse = [];
  if (allPossibleMatchAnalyseIds && allGameAnalyseMatchIds) {
    allPossibleMatchAnalyseIds.forEach(analyseIdsForDraws => {
      analyseIdsForDraws.forEach(analyseIdForDraw => {
        const matchingId = allGameAnalyseMatchIds.find(analyseIdForMatch => analyseIdForMatch === analyseIdForDraw);
        if (matchingId) {
          idsToUse.push(matchingId);
        }
      });
    });
  }
  return idsToUse;
};
const selectParticipantNamesByMatchId = (state, matchId) => state.gameAnalyses.drawData[matchId];
const selectAllMatchIdsFromAnalyses = state => {
  const allMatchIds = [];
  for (const _ref of Object.entries(state.gameAnalyses.matchAnalyses)) {
    var _ref2 = _slicedToArray(_ref, 2);
    const value = _ref2[1];
    const matchIds = value.gameInfo.sportEvents;
    for (const matchId of matchIds) {
      if (!allMatchIds.includes(matchId)) {
        allMatchIds.push(matchId);
      }
    }
  }
  return allMatchIds;
};
setGlobal('svs.components.sportinfo.gameAnalysesRedux.selectors', {
  selectAuthorProfiles,
  selectAuthorProfile,
  selectAnalysesByDraw,
  selectDrawAnalyses,
  selectMatchAnalyses,
  selectAnalysesByMatch,
  selectDrawAnalysesIsDone,
  selectDrawAnalysesIsRejected,
  selectDrawAnalysesShouldShowSkeleton,
  selectMatchAnalysis,
  selectMatchAnalysIdsForSpecificDrawAndMatchAndEventNumber,
  selectParticipantNamesByMatchId,
  selectAllMatchIdsFromAnalyses
});

 })(window);